<template>
  <sidebar-item :link="{name: $t('Атрибуты объектов'),  path: `/attrentity`,  icon: 'vip_icon icon_suppliers'}">
  </sidebar-item>
</template>
<script>
    export default {
        name: 'AttrEntityPage',
    }
</script>
